import { EBlockType } from '@/lib/enums';
import { IBlock, ICtaItem, IPostItem } from '@/lib/types';

export const CMS_PAGE_LOADING_TEST_IDS = {
  root: 'cms-page-loading',
} as const;

export const RENDERED_PAGE_CLASS =
  'renderedPage flex flex-col gap-5 px-[18px] md:gap-[22px] md:p-0';

const PLACEHOLDER_ASSET_URL = 'placeholder';

const createCtaPlaceholderItem = (): ICtaItem => ({
  type: EBlockType.CTA,
  text: '',
  redirectUrl: '',
  assetUrl: PLACEHOLDER_ASSET_URL,
});

const createPostPlaceholderItem = (
  contentType: EBlockType.ARTICLE | EBlockType.NEWS
): IPostItem => ({
  type: contentType,
  contentType,
  title: '',
  subTitle: '',
  date: '',
  slug: '',
  contentId: '',
});

export const CMS_PAGE_LOADING_PLACEHOLDER_BLOCKS: IBlock[] = [
  {
    type: EBlockType.CTA,
    itemsPerRow: 1,
    items: [createCtaPlaceholderItem()],
  },
  {
    type: EBlockType.CONTENTS_PREVIEW,
    contentType: EBlockType.NEWS,
    title: 'NEWS',
    itemsPerRow: 1,
    items: [createPostPlaceholderItem(EBlockType.NEWS)],
  },
  {
    type: EBlockType.CONTENTS_PREVIEW,
    contentType: EBlockType.ARTICLE,
    title: 'ARTICLES',
    itemsPerRow: 2,
    items: [
      createPostPlaceholderItem(EBlockType.ARTICLE),
      createPostPlaceholderItem(EBlockType.ARTICLE),
    ],
  },
];
